import { Callback } from '@/travelsuit/callback'

import { IAction } from './action-helpers'
import { LiveUserLocationsTypes as Types } from './actions.types'

export const Actions = {
	getLiveUserLocations(callback?: Callback, errCallback?: Callback): IAction {
		return {
			type: Types.GetLiveUserLocations.REQUEST,
			callback,
			errCallback,
		}
	},
}
